export enum AuthError {
  InvalidGrant = 'invalid_grant',
  //   TODO: Check for more possible error enums (JIRA ticket: TIN-575)
}
